var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReddit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_292",
    "data-name": "Group 292",
    xmlns: "http://www.w3.org/2000/svg",
    width: 153.469,
    height: 153.469,
    viewBox: "0 0 153.469 153.469",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    d: "M76.734,0A76.734,76.734,0,1,1,0,76.734,76.734,76.734,0,0,1,76.734,0Z",
    transform: "translate(0)",
    fill: "#a2a2a2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Fill-3",
    d: "M228.857,254.05a7.2,7.2,0,1,1,7.2-7.2,7.213,7.213,0,0,1-7.2,7.2m1.271,11.816c-4.92,4.906-14.331,5.293-17.1,5.293s-12.189-.387-17.1-5.293a1.867,1.867,0,1,1,2.64-2.64c3.1,3.1,9.715,4.2,14.455,4.2s11.36-1.106,14.456-4.2a1.86,1.86,0,0,1,2.64,0,1.885,1.885,0,0,1,0,2.64M189.982,246.85a7.2,7.2,0,1,1,7.2,7.2,7.213,7.213,0,0,1-7.2-7.2m69.1-7.2a10.067,10.067,0,0,0-17.067-7.242c-6.882-4.975-16.376-8.181-26.949-8.554l4.588-21.6,14.995,3.192a7.2,7.2,0,1,0,.732-3.524l-16.75-3.565a1.8,1.8,0,0,0-1.354.249,1.774,1.774,0,0,0-.774,1.133l-5.03,23.7a1.944,1.944,0,0,0,0,.4c-10.766.276-20.439,3.5-27.432,8.541a10.07,10.07,0,1,0-11.083,16.459,20.234,20.234,0,0,0-.235,3.054c0,15.506,18.049,28.068,40.312,28.068s40.312-12.562,40.312-28.068a20.015,20.015,0,0,0-.235-3.026,10.12,10.12,0,0,0,5.97-9.218",
    transform: "translate(-136.306 -163.521)",
    fill: "#273c49"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReddit);
export default __webpack_public_path__ + "static/media/reddit.d58a6f8054421505fb4f47a8caf0bd14.svg";
export { ForwardRef as ReactComponent };